import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../components/styled";

// Confirmation modal for submitting a DRAFT change request. Closed
// while submitting so the user can't dismiss mid-request.
export default function SubmitChangeRequestModal({
  open,
  onClose,
  onConfirm,
  submitting,
}) {
  const safeClose = () => {
    if (submitting) return;
    onClose?.();
  };
  return (
    <Dialog
      open={open}
      onClose={safeClose}
      PaperProps={{
        sx: { borderRadius: "12px", width: "min(420px, 92vw)" },
      }}
    >
      <Box sx={{ padding: "20px 24px 8px" }}>
        <Box
          component="p"
          sx={{
            margin: 0,
            fontSize: 18,
            fontWeight: 600,
            color: "#0D0D0E",
            fontFamily: "Inter Tight",
          }}
        >
          Submit Change Request?
        </Box>
      </Box>
      <DialogContent sx={{ pt: 1 }}>
        <Typography
          sx={{
            fontSize: 14,
            color: "#4B5563",
            fontFamily: "Inter Tight",
          }}
        >
          Are you sure you want to submit this change request?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2.5,
          pt: 1,
          display: "flex",
          gap: 2,
          justifyContent: "space-between",
        }}
      >
        <SecondaryButton onClick={safeClose} disabled={submitting}>
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={onConfirm} disabled={submitting}>
          {submitting ? "Submitting..." : "Submit"}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
